// import { RiLogoutBoxLine } from "react-icons/ri";
// import { useNavigate } from "react-router-dom";
const ImageAndLogout = () => {
  // const navigate = useNavigate();
  // const logout = () => {
  //   window.localStorage.removeItem("user");
  //   navigate("/");
  // };
  return (
    <div className="flex-col gap-4">
      {/* <img className="py-12" src='images/imageSidebar.svg' alt='Image' /> */}
      {/* <a
        onClick={logout}
        className="flex items-center gap-4 text-gray-400 hover:bg-green-600 p-4 px-10 hover:text-white rounded-lg transition-colors"
      >
        <RiLogoutBoxLine />
        Cerrar sesión
      </a> */}
    </div>
  );
};
export default ImageAndLogout;